import { deriveCategory, type ModelType } from "@gunziai/ai-sdk/interfaces";
import type { AiProvider } from "@gunziai/services/web";

import type { Model } from "../types";

interface ConvertProvidersToModelsOptions {
  dedupe?: boolean;
}

export function convertProvidersToModels(
  providers: AiProvider[],
  options: ConvertProvidersToModelsOptions = {},
): Model[] {
  const models: Model[] = [];
  const modelMap = new Map<string, Model>();
  const dedupe = options.dedupe ?? true;

  providers.forEach((provider) => {
    if (!provider.models || provider.models.length === 0) {
      return;
    }

    provider.models.forEach((model) => {
      if (!model.isActive) {
        return;
      }

      const modelKey = model.model || model.id;

      if (dedupe && modelMap.has(modelKey)) {
        const existingModel = modelMap.get(modelKey)!;
        if (!existingModel.providers.includes(provider.provider)) {
          existingModel.providers.push(provider.provider);
        }
      } else {
        // category 优先用后端返回值，否则按 modelType 推导（兼容未升级的 API）
        const category =
          model.category ||
          (model.modelType ? deriveCategory(model.modelType as ModelType) : undefined);

        const newModel: Model = {
          id: model.id,
          name: model.name,
          model: model.model,
          chef: provider.name,
          chefSlug: provider.provider,
          providerId: provider.id,
          providers: [provider.provider],
          providerSortOrder: provider.sortOrder,
          providerCreatedAt: provider.createdAt,
          features: model.features,
          modelConfig: model.modelConfig,
          thinking: model.thinking,
          enableThinkingParam: model.enableThinkingParam,
          modelType: model.modelType,
          category,
          billingRule: model.billingRule,
          imageBillingPower: model.imageBillingPower,
          videoBillingPower: model.videoBillingPower,
          iconUrl: provider.iconUrl,
          membershipLevel: model.membershipLevel,
        };
        modelMap.set(modelKey, newModel);
        models.push(newModel);
      }
    });
  });

  return models;
}
